// InternalRating sections that other modules' pages embed (#253): the two
// lists on /account/my-ratings. Registered from `./index` at bootstrap; the
// page renders them by id and does not import InternalRating.
// Contract: `src/lib/slots.tsx`. Registrations only.
import { registerSlot } from '@/lib/slots'

registerSlot({
    id: 'internal-rating.received-list',
    load: () => import('./components/MyRatings/ReceivedList'),
})
registerSlot({
    id: 'internal-rating.awaiting-list',
    load: () => import('./components/MyRatings/AwaitingList'),
})
